import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Column, Row } from '@chargify/custom-ui-components';
import { ContactDetailsModel } from '../../models/customerDetails';
import { ConfigContext } from '../../contexts';
import { DetailsRow } from '../DetailsRow';

import {
  getFullName,
  getFullNameLabel,
  getVisibleContactDetailsFields,
} from './utils';

export interface ContactDetailsProps {
  contactDetails: ContactDetailsModel;
  onEdit: () => void;
  editAllowed: boolean;
}
const ContactDetails = ({
  contactDetails,
  onEdit,
  editAllowed,
}: ContactDetailsProps) => {
  const { t } = useTranslation(['customer-details']);
  const { customerProfile } = useContext(ConfigContext);
  const { customerDataVisibleFields } = customerProfile;

  const {
    firstName,
    lastName,
    email,
    phoneNumber,
    ccEmails,
    organization,
    vatNumber,
  } = useMemo(
    () =>
      getVisibleContactDetailsFields(contactDetails, customerDataVisibleFields),
    [contactDetails, customerDataVisibleFields]
  );

  return (
    <Box>
      <Row>
        <DetailsRow
          label={t('contact_details.organization_name')}
          value={organization}
        />
        <DetailsRow
          label={getFullNameLabel(t, firstName, lastName)}
          value={getFullName(firstName, lastName)}
        />
        <DetailsRow label={t('contact_details.phone')} value={phoneNumber} />
        <DetailsRow label={t('contact_details.email')} value={email} />
        <DetailsRow
          label={t('contact_details.emails_cc')}
          value={ccEmails?.join(', ')}
          hint={t('contact_details.email_hint')}
        />
        <DetailsRow label={t('contact_details.vat_number')} value={vatNumber} />
        <Column span={24}>
          {editAllowed ? (
            <Button
              onClick={onEdit}
              color={'secondary'}
              iconLeft="edit"
              label={t('contact_details.edit_contact_details')}
            />
          ) : null}
        </Column>
      </Row>
    </Box>
  );
};
export default ContactDetails;
